<template>
  <CarouselSelector
    key="carouselPlatformSelector"
    v-model="platform"
    v-validate.disable="'required'"
    :label="$$t('Platforms:', 'platforms_label')"
    multi-select
    required
    :read-only="isTournamentFieldDisabled('platform')"
    prop-name="value"
    :items="platformsList"
    :error="errors.first('platform')"
    variant="medium"
    data-vv-name="platform"
    class="mt-5 tournament-info-wrapper__platform-carousel"
    :empty-text="
      $$t(`We do not support this platform`, 'platforms_selector_empty')
    "
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import CarouselSelector from '@/components/common/CarouselSelector';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentPlatformSetting',
  inject: ['$validator'],
  components: {
    CarouselSelector,
  },
  mixins: [translate('_web_tournament_settings')],

  computed: {
    ...mapGetters([
      'currentTournament',
      'publishedPlatforms',
      'platformByID',
      'gameByID',
      'isTournamentFieldDisabled',
    ]),
    platform: {
      get() {
        return this.$lodash.get(this.currentTournament, 'info.platforms', []);
      },
      set(val) {
        this.updateCurrentTournament({
          platforms: val,
          component: 'info',
        });
      },
    },
    platformsList() {
      const game = this.gameByID(
        this.$lodash.get(this.currentTournament, 'info.game', false)
      );
      return this.$lodash
        .get(game, 'platforms', this.publishedPlatforms)
        .map(item => {
          item = this.$lodash.isString(item) ? this.platformByID(item) : item;
          return {
            value: item.id,
            img: item.logo.uri,
            title: item.name,
          };
        });
    },
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
  },
};
</script>
<style lang="scss">
.tournament-info-wrapper__platform-carousel {
  min-height: 84px;
  margin-left: 20px;
  padding-bottom: 20px;
  justify-content: center;
}

.tournament-info-wrapper__platform-carousel .playhera-label {
  padding-bottom: 20px;
  font-size: $hr-text-small !important;
  font-weight: 600;
  .app-rtl & {
    margin-right: 20px;
  }
}

.tournament-info-wrapper__platform-carousel .list-unstyled {
  margin-left: 19px;
}
</style>
